import UserMediaService from "../services/UserMediaService";

export class Sound {
  private streamSource?: MediaStream;
  private elementSource?: HTMLAudioElement;
  private _source: AudioNode;

  constructor(trackOrStreamOrSrc: MediaStreamTrack | MediaStream | string) {
    if (trackOrStreamOrSrc instanceof MediaStreamTrack) {
      this.streamSource = new MediaStream([trackOrStreamOrSrc]);
    }
    else if (trackOrStreamOrSrc instanceof MediaStream) {
      this.streamSource = trackOrStreamOrSrc;
    }
    else {
      this.elementSource = new Audio(trackOrStreamOrSrc);
      this.elementSource.play();
    }
    this._source = this.createAudioNode();
  }

  createAudioNode(): AudioNode {
    const audioContext = UserMediaService.getAudioContext();
    if (this.streamSource) {
      const source = audioContext.createMediaStreamSource(this.streamSource);
      return source;
    }
    else if (this.elementSource) {
      const source = audioContext.createMediaElementSource(this.elementSource);
      return source;
    }
    else {
      throw new Error('No MediaStream or HTMLAudioElement found');
    }
  }

  get source(): AudioNode {
    return this._source;
  }

  get stream(): MediaStream | undefined {
    return this.streamSource;
  }

  disconnect() {
    this._source.disconnect();
  }
}